export default "__VITE_ASSET__DKVUGFPN__"